import React, { useState, useEffect } from 'react';
import productDetails from './products_details.json';

function ProductOptions({ selectedProduct, setSelectedProduct }) {
    const [products, setProducts] = useState([]);

    useEffect(() => {
        const uniqueProducts = [...new Set(productDetails.map(product => product.size))].map(size => productDetails.find(p => p.size === size));
        setProducts(uniqueProducts);
    }, []);

    return (
        <div className="product-options">
            <h5>Wähle deine Größe:</h5>
            <div className="sizes">
                {products.map(product => (
                    <button 
                    className={`size-button ${product.size === selectedProduct?.size ? 'active' : ''}`}
                    key={product.size} onClick={() => setSelectedProduct(product)}>
                        {product.size}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default ProductOptions;
